import { ApolloLink } from '@apollo/client';
import { addBreadcrumb, getCurrentHub } from '@sentry/react';
import { OperationMetadata } from './operation-metadata';
export const sentryGraphContext = new ApolloLink((operation, forward) => {
  const operationData = new OperationMetadata(operation);
  addSpanTraceForGraphOperation(operationData);

  return forward(operation).map((data) => {
    const context = operation.getContext();
    const { response } = context;
    const ecid = response.headers.get('x-execution-correlation-id');
    addBreadcrumb({
      type: 'http',
      category: `graphql.${operationData.getType()}`,
      data: { operationName: operationData.getName(), ecid: ecid },
      level: 'info'
    });
    return data;
  });
});

const addSpanTraceForGraphOperation = (operationData: OperationMetadata) => {
  const transaction = getCurrentHub()?.getScope()?.getTransaction();
  if (!transaction) return;
  if (transaction) {
    const span = transaction.startChild({
      op: 'http.client.nextGraphOperation',
      description: `${operationData.getType()}.${operationData.getName()}`
    });
    span.finish();
  }
};
